import { defineStore } from "pinia";
import { fetchOrganizationSnapshot } from "@/api/helpContentApi";

/**
 * Cached org name for the logged-in account (accounts.organization).
 * Shared across help labels and any other org-branded UI.
 */
export const useOrganizationStore = defineStore("organization", {
  state: () => ({
    accountnumber: "",
    organizationName: "",
    loadedKey: "",
    loading: false,
    error: null,
  }),

  getters: {
    /** e.g. "Erriff Health-specific" */
    orgSpecificLabel(state) {
      const name = String(state.organizationName || "").trim();
      return name ? `${name}-specific` : "Organization-specific";
    },
  },

  actions: {
    clear() {
      this.accountnumber = "";
      this.organizationName = "";
      this.loadedKey = "";
      this.loading = false;
      this.error = null;
    },

    /** Fetch once per accountnumber unless force=true. */
    async ensureLoaded(accountnumber, { force = false } = {}) {
      const key = String(accountnumber || "").trim();
      if (!key) {
        this.error = "missing_account";
        return false;
      }
      if (!force && this.loadedKey === key) return true;
      if (this.loading) return false;

      this.loading = true;
      this.error = null;
      try {
        const result = await fetchOrganizationSnapshot(key);
        if (result?.status !== "Successful" || !result?.data) {
          this.error = result?.message || result?.status || "load_failed";
          this.organizationName = "";
          this.accountnumber = key;
          this.loadedKey = "";
          return false;
        }
        this.accountnumber = String(result.data.accountnumber || key);
        this.organizationName = String(result.data.organization || "").trim();
        this.loadedKey = key;
        return true;
      } catch (err) {
        this.error = err?.message || "load_failed";
        return false;
      } finally {
        this.loading = false;
      }
    },
  },
});
